export const memberClickBind = () => {
	$('#toggleHistory').on('click', function() {
        $("#labelHistory").toggle();
        $("#toggleHistory").text() == "Show All +" ? $("#toggleHistory").text("Hide All -") : $("#toggleHistory").text("Show All +");

    });
    $('#enter-alt-address').on('click', function() {
        $('.alt-address-area').show();
    });
    $('#current-address').prop('check', true);
};
